import { render, staticRenderFns } from "./WineNaming.vue?vue&type=template&id=259c1088"
import script from "./WineNaming.vue?vue&type=script&lang=js"
export * from "./WineNaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('259c1088')) {
      api.createRecord('259c1088', component.options)
    } else {
      api.reload('259c1088', component.options)
    }
    module.hot.accept("./WineNaming.vue?vue&type=template&id=259c1088", function () {
      api.rerender('259c1088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/WineNaming.vue"
export default component.exports